import styled from 'styled-components'

import theme, { ScreenBreakpoints } from '../../theme'

const CardContainerWrapper = styled.div`
  background-color: ${theme.colors.lightBackground};
  padding: 8px;
  border-radius: 4px;

  &.disabled {
    background-color: rgba(241, 242, 243, 0.3);
  }
  &.disabled .title {
    color: ${theme.colors.gray8};
    opacity: 0.3;
    background-color: rgba(241, 242, 243, 0.01);
  }
  &.disabled .card-flex-wrapper {
    background-color: rgba(241, 242, 243, 0.01);
  }
`

const CardFlexWrapper = styled.div`
  background-color: ${theme.colors.lightBackground};
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding-top: 8px;
  gap: 8px;
  border-radius: 4px;

  .card-wrapper {
    width: 100%;

    @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
      width: calc(50% - 4px);
    }
  }
`
const Title = styled.span`
  background-color: ${theme.colors.lightBackground};
  font-size: ${theme.fontSizes.small};
  font-weight: ${theme.fontWeights.semiBold};
  color: ${theme.colors.gray8};
`

export { CardFlexWrapper, Title, CardContainerWrapper }
